// extracted by mini-css-extract-plugin
module.exports = {"container":"backdrop_container__1rR9d","row":"backdrop_row__2bqqD","column":"backdrop_column__13opi","backdrop-container":"backdrop_backdrop-container__1GkOx"};